import type { DefaultPaymentLogsListParams, DefaultPaymentLogsSortKey } from '../../types/pages'

export const PAYMENT_STATUS_LABELS: Record<string, string> = {
  OnHold: 'OnHold',
  PendingPaymentAuthorization: 'Liberty Pending',
  ExternalPending: 'External Pending',
  ACH_Check_Pending: 'ACH Check Pending',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
  Recovered: 'Recovered',
}

export const DEFAULT_DEFAULT_PAYMENT_LOGS_PARAMS: DefaultPaymentLogsListParams = {
  page: 1,
  perPage: 15,
  sortBy: 'desc',
  orderBy: 'payment_log_id',
  q: '',
  property_id: '',
  company_id: '',
  fromDt: '',
  toDt: '',
  payment_verified: '',
  payment_status: [],
  claim_status: '',
  vintage_year: '',
  lease_start_fromDt: '',
  lease_start_toDt: '',
  claim_status_fromDt: '',
  claim_status_toDt: '',
  is_reissue_payment: '',
}

export const DEFAULT_PAYMENT_LOGS_SORT_COLUMNS: { key: DefaultPaymentLogsSortKey; label: string }[] = [
  { key: 'payment_log_id', label: 'Log Id' },
  { key: 'company_name', label: 'Company' },
  { key: 'property_name', label: 'Property' },
  { key: 'fk_applicant_id', label: 'Resident' },
  { key: 'first_name', label: 'Name' },
  { key: 'contract_start_date', label: 'Contract Start Date' },
  { key: 'payment_notes', label: 'Notes' },
  { key: 'payment_source', label: 'Payment Source' },
  { key: 'auth_code', label: 'Check #' },
  { key: 'vintage_year', label: 'Vintage Year' },
  { key: 'payment_amount', label: 'Total Amount' },
  { key: 'created_at', label: 'Payment Date' },
  { key: 'payment_status', label: 'Payment Status' },
  { key: 'claim_status', label: 'Reimbursement Status' },
  { key: 'payment_verified', label: 'Payee Verified' },
  { key: 'pay_to', label: 'Paid To' },
]
